import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { CRM_NAV } from './nav';

const AccountManagement: React.FC = () => {
    const { api } = useInternalApi();
    const [accounts, setAccounts] = useState<any[]>([]);
    const [meta, setMeta] = useState<any>({});
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Account Management - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('crm-api/accounts/').then(r => {
            if (r.data?.status === 'success') {
                setAccounts(r.data.data.accounts || []);
                setMeta(r.data.data);
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="customer_relations" subNav={CRM_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faBuilding} className="me-2 text-primary" />Account Management</h2>
            <p className="text-muted mb-4">Institution accounts, their footprint and when they were last contacted</p>

            {meta.partner_network_row_count === 0 && (
                <div className="alert alert-secondary small">
                    <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                    The separate marketplace Partner network has no accounts yet (0 records) — that area is tied to an open architectural decision. This page manages the real <strong>institution</strong> accounts on the platform.
                </div>
            )}

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <>
                    <div className="row mb-4">
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Institution accounts</div><h4>{accounts.length}</h4>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Active stakeholders</div><h4>{meta.stakeholders ?? 0}</h4>
                        </div></div></div>
                        <div className="col-md-3 mb-3"><div className="card border-0 shadow-sm"><div className="card-body">
                            <div className="text-muted small mb-1">Open stakeholder requests</div><h4>{meta.open_stakeholder_requests ?? 0}</h4>
                        </div></div></div>
                    </div>

                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-0">
                            {accounts.length === 0 ? (
                                <div className="text-center py-5 text-muted">No institution accounts yet.</div>
                            ) : (
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="table-light"><tr><th>Account</th><th>Town</th><th>Clinics</th><th>Staff</th><th>Interactions</th><th>Last contact</th><th>Status</th></tr></thead>
                                    <tbody>
                                        {accounts.map(a => (
                                            <tr key={a.principal_id}>
                                                <td><strong>{a.name}</strong><div className="small text-muted">{a.email}</div></td>
                                                <td>{a.town || '—'}</td>
                                                <td>{a.clinics}</td>
                                                <td>{a.staff}</td>
                                                <td>{a.interactions > 0 ? <span className="badge bg-info">{a.interactions}</span> : <span className="text-muted">none</span>}</td>
                                                <td className="small">{a.last_contact ? new Date(a.last_contact).toLocaleDateString() : <span className="text-warning">Never</span>}</td>
                                                <td><span className={`badge ${a.active ? 'bg-success' : 'bg-secondary'}`}>{a.active ? 'Active' : 'Suspended'}</span></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </>
            )}
        </InternalShell>
    );
};

export default AccountManagement;
